import React, { Component } from 'react';
import {  Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {  Col, Row } from 'react-bootstrap';
import { format } from 'date-fns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { userGroupUrlCheck, getUserTimeZone } from '../../../utils/userGroupUrlCheck';
import { converDateToLocal } from '../../../utils/commonUtilities';

import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_RECORDED_ADDED_SUCCESS, MSG_NOT_FOUND, MSG_NO_INPUT_PROVIDED, MSG_RECORDED_DELETE_SUCCESS, MSG_RECORDED_UPDATED_SUCCESS, MSG_DELETE_VECHICLE_DETAILS, MSG_ADD_MANDATORY_DATA } from '../../../configs/msgConfigs';
import { LBL_APPROVED, LBL_ACTIONS, LBL_EDIT, LBL_DELETE, LBL_EDIT_VEHICLE, LBL_ADD_VEHICLE,  LBL_AFFILIATE_VEHICLE_LIST, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_VEHICLE_INFO, LBL_APP_NAME, LBL_SETTINGS, LBL_YES, LBL_NO, LBL_CONFIRM_DELETE, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';
import { LOGIN_AFFILIATE_GROUP, STR_VEHICLE_INFO, ROUTE_AFFILIATE_SETTINGS } from '../../../configs/staticConfigs';

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import { clearAction } from '../../../actions/commonActions';
import { listFieldDetails, saveFieldDetails, saveVehicleInfo, listVehicleInfo, deleteVehicleInfo, updateVehicleInfo, getVehicleInfo } from '../../../actions/settings/affiliates/vehicleInfoAction';
import { dynamicFieldsListAction } from '../../../actions/settings/dynamicFieldsActions'; 
import { GET_VEHICLE_INFO_SUCCESS, SAVE_FIELD_DETAILS_SUCCESS, SAVE_VEHICLE_INFO_SUCCESS, LIST_VEHICLE_INFO_SUCCESS, UPDATE_VEHICLE_INFO_SUCCESS, DELETE_VEHICLE_INFO_SUCCESS, DYNAMIC_FIELDS_LIST_SUCCESS } from '../../../actions';
class AffiliateVehicleInfo extends Component {

    constructor(props) {
        super(props)
        this.vehicleDetailsModal = React.createRef();
        let userGroupData = userGroupUrlCheck(this.props.location);
        let profileId = '';
        if (userGroupData !== undefined) {
            profileId = userGroupData.profile_id;
        }
        let timeZone = getUserTimeZone(this.props.location);
        this.state = {
            formErrors: {},
            infoFormErrors: {},
            commonErrMsg: '',
            valueErrMsg: '',
            fieldDetails: [],
            affiliate: parseInt(profileId),
            toastMessagePop: '',
            toastFlagPop: false,
            toastSuccessPop: true,
            vehicleDetailsHeader: LBL_ADD_VEHICLE,
            vehicleInfoDetailedList: [],
            vehicleInfoValue: {},
            activeRowId: 0,
            deleteId: 0,
            timeZone: timeZone,
            editId: 0,
            vehFieldId: '',
            initialValidation:false
        }
        this.modalDelete = React.createRef();
    }

    onCloseToastPop = () => { // USED FOR POPUP clientContactAdd
        this.setState({ toastFlagPop: false, toastMessagePop: '', toastSuccessPop: false });
    }

    setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
        this.setState({ toastFlagPop: isEnabled, toastMessagePop: message, toastSuccessPop: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToastPop();
            }, 3000);
        }
    }

    componentDidMount() {
        document.body.classList.add('body-affiliate');
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " -  " + LBL_VEHICLE_INFO;
        // this.props.listFieldDetails();
        // FETCH AFFILITATE VEHICLE DYNAMIC FIELDS 
        let listDynData = {groupId:LOGIN_AFFILIATE_GROUP, reqFrom:LOGIN_AFFILIATE_GROUP}; 
        this.props.dynamicFieldsListAction(listDynData); 
        this.props.listVehicleInfo();
    }

    componentDidUpdate(prevProps) {
        let { vehicleInfoActivity, vehicleInfoStatus, fieldDetailsList, vehicleInfoList, vehicleInfoRetrieve, dynFieldsAllItems, dynFieldsStatus, dynFieldsActivity } = this.props;

        if ((dynFieldsActivity !== prevProps.dynFieldsActivity) || (dynFieldsStatus!== prevProps.dynFieldsStatus)) { 
            var arrRespMaster = dynFieldsActivity.split('~~');
            var actStringMaster = arrRespMaster[0];
            if (actStringMaster === DYNAMIC_FIELDS_LIST_SUCCESS) {
                this.props.clearAction();
                let vehicleFields = []; 
                let aciveFields = []; 
                let field_details = []; 
                let vehFieldId = ''; 
                vehicleFields = dynFieldsAllItems.filter(item => item.name.trim().toLowerCase()===STR_VEHICLE_INFO.toLowerCase());
                
                aciveFields = vehicleFields[0].field_details; 
                vehFieldId = vehicleFields[0].id; 
                this.setInfoFormError();
                this.props.clearAction();
                let { formErrors } = this.state;
                if (aciveFields && aciveFields.length > 0) { 
                    aciveFields.map((item, index) => {
                        item.field_ref_id = item.field_id;
                        item.field_id = index;
                        field_details.push(item)
                    })
                }
                
                this.setState({ fieldDetails: field_details, formErrors: formErrors, vehFieldId });
            }
        }

        if (vehicleInfoActivity && (vehicleInfoStatus !== prevProps.status || vehicleInfoActivity !== prevProps.activity)) {
            var arrResp = vehicleInfoActivity.split('~~');
            var actString = arrResp[0];

            if (actString === SAVE_FIELD_DETAILS_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_ADDED_SUCCESS, true);
                //this.props.listFieldDetails();
            }
            if (actString === LIST_VEHICLE_INFO_SUCCESS) {
                this.props.clearAction();
            }
            if (actString === SAVE_VEHICLE_INFO_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_ADDED_SUCCESS, true);
                this.props.listVehicleInfo();
            }
            if (actString === UPDATE_VEHICLE_INFO_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_UPDATED_SUCCESS, true);
                this.props.listVehicleInfo();
            }
            if (actString === DELETE_VEHICLE_INFO_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_DELETE_SUCCESS, true);
                this.props.listVehicleInfo();
            }
            if (actString === GET_VEHICLE_INFO_SUCCESS) {
                this.props.clearAction();
                let vehicleInfoValue = {}
                let { infoFormErrors } = this.state;
                vehicleInfoRetrieve.affiliatevehicledetails_set.map((item, index) => {
                    console.log('item: ',JSON.stringify(item)); 
                    let value = '';
                    this.state.fieldDetails.map((fieldItem, fieldIndex) => {
                        if (fieldItem.field_ref_id === item.field_id) {
                            if (fieldItem.field_type === 'string') {
                                value = item.text_value; 
                                vehicleInfoValue[item.field_id] = value;
                            } else {
                                value = new Date(converDateToLocal(item.date_value, this.state.timeZone.utc_offset, 'yyyymmdd'));
                                vehicleInfoValue[item.field_id] = value;
                            }

                            if (!value || value === '' || value === null) {
                                infoFormErrors[item.field_id] = "input-error";
                            } else {
                                infoFormErrors[item.field_id] = "";
                            }
                        }
                    })
                })
                vehicleInfoValue['is_approved'] = vehicleInfoRetrieve.is_approved;
                this.setState({ vehicleInfoValue: vehicleInfoValue, infoFormErrors: infoFormErrors }, () => {
                    this.vehicleDetailsModal.current.handleOpenModal();
                })
            }
        }
    }

    onHandleVehicleInfoChange = (e, item, type) => {
        let value = '';
        let { vehicleInfoValue, infoFormErrors } = this.state;
        if (type === 'string') {
            value = e.target.value;
        } else {
            if (e === '' || e === null) {
                value = new Date();
            } else {
                value = new Date(e);
            }
        }
        vehicleInfoValue[item.field_ref_id] = value;  
        if (Object.keys(infoFormErrors).indexOf(item.field_ref_id.toString()) !== -1) {  
            if (!value || value.trim() === "" || value === null) {
                infoFormErrors[item.field_ref_id] = "input-error";  
            } else {
                infoFormErrors[item.field_ref_id] = "";  
            }

        }
        this.setState({ vehicleInfoValue: vehicleInfoValue, infoFormErrors: infoFormErrors })
    }

    //Add details part
    addVehicleDetails = (e) => {
        this.setInfoFormError();
        // SET DEFAULT VALUES TO STRING AND DATE FIELDS  
        let { vehicleInfoValue, fieldDetails } = this.state;

        if(fieldDetails && Array.isArray(fieldDetails) && fieldDetails.length > 0) {
           fieldDetails.forEach(item => {
                vehicleInfoValue[item.field_ref_id] = item.field_type === 'date' ? new Date() : '';
           }); 
        }

        vehicleInfoValue.is_approved = false; 

        this.setState({ editId: 0, vehicleDetailsHeader: LBL_ADD_VEHICLE, vehicleInfoValue }, () => {
            this.vehicleDetailsModal.current.handleOpenModal();
        })
    }

    setInfoFormError = () => {
        let infoFormErrors = {};
        // this.props.fieldDetailsList
        if(this.state.fieldDetails && Array.isArray(this.state.fieldDetails)) {
            this.state.fieldDetails.map((item, index) => {
                if (item.is_mandatory) {
                    // infoFormErrors[item.id] = "input-error";
                    infoFormErrors[item.field_ref_id] = "input-error";
                }
            })
        }
        this.setState({ infoFormErrors: infoFormErrors })
    }

    onSaveFormData = (e) => {
        let { vehicleInfoValue, fieldDetails } = this.state;
        this.setState({ initialValidation: true });
        let flag = true;
        Object.values(vehicleInfoValue).map((item, index) => {
            if (item !== "" || item !== null) {
                flag = false;
            }
        });
        Object.values(this.state.infoFormErrors).map((item, index) => {
            if (item === 'input-error') {
                flag = true;
            }
        })

        let tmpFieldDetails = fieldDetails; 

        tmpFieldDetails.map((fieldItem, fieldIndex) => {
            if(!vehicleInfoValue[fieldItem.field_ref_id] || vehicleInfoValue[fieldItem.field_ref_id].trim().length===0) {
                this.setToasterStatePop(true,MSG_ADD_MANDATORY_DATA,false,true);
                flag = true;
                return false; 
            }
        })

        if (flag) {
            this.setState({ valueErrMsg: MSG_NO_INPUT_PROVIDED })
        } else {
            let vehicleSaveObj = [];
            fieldDetails.map((fieldItem, fieldIndex) => {
                if(!vehicleInfoValue[fieldItem.field_ref_id] || vehicleInfoValue[fieldItem.field_ref_id].trim().length===0) {
                    this.setToasterStatePop(true,MSG_ADD_MANDATORY_DATA,false,true);
                    return false; 
                }
                
                // if (Object.keys(vehicleInfoValue).indexOf(fieldItem.field_id.toString()) !== -1) { // id
                if (vehicleInfoValue[fieldItem.field_ref_id].toString() !== -1) { // id

                    let text_value = '';
                    let date_value = null;

                    if (fieldItem.field_type === 'string') {
                        text_value = vehicleInfoValue[fieldItem.field_ref_id]; // id
                    } else {
                        date_value = format(vehicleInfoValue[fieldItem.field_ref_id], 'yyyy-MM-dd'); // id
                    }
                    vehicleSaveObj.push({
                        "field_name": fieldItem.field_name, "field_type": fieldItem.field_type, "text_value": text_value,
                        "date_value": date_value, "field_info_id": this.state.vehFieldId, "field_id": fieldItem.field_ref_id    
                    }); // id 

                    console.log('vehicleSaveObj: ',vehicleSaveObj); 
                }

            })
            if (this.state.editId !== 0) {
                this.props.vehicleInfoRetrieve.affiliatevehicledetails_set.map((item, index) => {
                    vehicleSaveObj.map((vehItem, index) => {
                        if (vehItem.field_id === item.field_id) {
                            vehItem['id'] = item.id
                        }
                    })
                })
                this.props.updateVehicleInfo({ id: this.state.editId, vehicle_details: vehicleSaveObj, is_approved: vehicleInfoValue.is_approved })
            } else {
                this.props.saveVehicleInfo({ vehicle_details: vehicleSaveObj, is_approved: vehicleInfoValue.is_approved });
            }
            this.vehicleDetailsModal.current.handleModelClose()
        }
    }

    onModalFormReset = (e) => {
        this.setState({ initialValidation: false});
        // this.vehicleDetailsModal.current.handleCloseModal();       

    }
    onShowActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        } else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        } else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    editVehicleBtnClick = (e, id) => {
        this.setInfoFormError();
        this.props.getVehicleInfo(id);
        this.setState({ editId: id, vehicleDetailsHeader: LBL_EDIT_VEHICLE });
    }
    deleteVehicleBtnClick = (e, id) => {
        this.setState({ deleteId: id }, () => {
            this.modalDelete.current.handleOpenModal();
        });
    }
    onDeleteAction = () => {
        this.props.deleteVehicleInfo(this.state.deleteId);
        this.modalDelete.current.handleModelClose();
    }
    onHandleIsApprovedChange = (e) => {
        let { vehicleInfoValue } = this.state;
        let checked = e.target.checked;
        vehicleInfoValue['is_approved'] = checked;
        this.setState({ vehicleInfoValue: vehicleInfoValue })
    }

    render() {
        let { fieldDetails, toastMessagePop, toastSuccessPop, toastFlagPop } = this.state;
        let fieldId = '';
        let newDate = new Date();
        let timeZone = getUserTimeZone(this.props.location);
    

        return (
            <>
            <div className='row' style={{width: '100%'}}>
                <div className='margin-left-30 margin-bottom-5 padding-left-3 padding-top-5 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
            </div>
            <div className="col-md-8">
                <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToastPop} />
                <div className="box">
                    {fieldDetails.length > 0 && <div className="tab-head tdVeticalMiddle">
                        <div className="float-left tdVeticalMiddle btn marginLeft0"><h6>{LBL_AFFILIATE_VEHICLE_LIST}</h6></div>
                        <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addVehicleDetails(e)} >{LBL_BTN_ADDNEW}</button></div>
                    </div>}
                    <div className="box-content">
                        <div className="table-responsive">
                            
                            {fieldDetails.length > 0 &&
                                <><table id="data-table" className="table" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th className="text-center">{LBL_SLNUM}</th>
                                            {fieldDetails && Array.isArray(fieldDetails) && fieldDetails.map((item, index) => {
                                                return (
                                                    <th key={index} className="text-center">{item.field_name}</th>
                                                )
                                            })
                                            }
                                            <th className="text-center ">{LBL_APPROVED}</th>
                                            <th className="max-width-100">{LBL_ACTIONS}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(!this.props.vehicleInfoList || !Array.isArray(this.props.vehicleInfoList) || this.props.vehicleInfoList.length === 0) &&
                                            <tr>
                                                <td colSpan={fieldDetails.length ? fieldDetails.length + 2 : 1} className="text-center">{MSG_NOT_FOUND}</td>
                                            </tr>
                                        }
                                        {this.props?.vehicleInfoList && Array.isArray(this.props.vehicleInfoList) && this.props.vehicleInfoList.length > 0 && this.props.vehicleInfoList.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {index + 1}
                                                    </td>
                                                    {fieldDetails.map((fieldItem, fieldIndex) => {
                                                        let value = ''

                                                        item.affiliatevehicledetails_set.map((valItem, valIndex) => {
                                                            if (valItem.field_id === fieldItem.field_ref_id) { 
                                                                if (fieldItem.field_type === 'string') {
                                                                    value = valItem.text_value
                                                                } else {
                                                                    value = converDateToLocal(valItem.date_value, timeZone.utc_offset, 'ddmmyyyy');
                                                                }

                                                            }
                                                        })

                                                        return (<td key={fieldIndex} className="text-center">
                                                            {value}
                                                        </td>
                                                        )
                                                    })}

                                                    <td className="text-center">
                                                        {item.is_approved ? LBL_YES : LBL_NO}
                                                    </td>

                                                    <td className="max-width-100">
                                                        <div className={"dropdown"} id={'dropdown-' + index}>
                                                            <button className="dropdown-toggle" type="button"
                                                                id={'dropdownMenuButton-' + index} data-toggle="dropdown"
                                                                aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, index)} >
                                                                <input type="image" id={"img-action-" + index} src={require('../../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, index)} ></input>
                                                            </button>
                                                            <div className="dropdown-menu" id={'dropdown-menu-' + index}
                                                                aria-labelledby={'dropdownMenuButton-' + index}>
                                                                <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editVehicleBtnClick(e, item.id)}>{LBL_EDIT}</Link>
                                                                <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.deleteVehicleBtnClick(e, item.id)}>{LBL_DELETE}</Link>

                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )

                                        })

                                        }
                                    </tbody>
                                </table>
                                    <div className="clear-b-scroll-sector">&nbsp;</div>
                                    <div className="clear-b-scroll-sector">&nbsp;</div></>
                            }
                            {fieldDetails.length === 0 &&
                                <table id="data-table" className="table" style={{ width: "100%" }}>
                                    <tr>
                                        <td colSpan="13" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                </table>
                            }
                        </div>
                    </div>
                </div>



                <ModalWindow modalId="vehicleDetailsModal" ref={this.vehicleDetailsModal} header={this.state.vehicleDetailsHeader} saveFormData={(e) => this.onSaveFormData(e)} resetModalForm={(e) => this.onModalFormReset(e)} type="save" >
                    <Row>
                        {fieldDetails && Array.isArray(fieldDetails) && fieldDetails.length > 0 && fieldDetails.map((item, index) => {
                            fieldId = item.field_ref_id;
                            return (
                                <Col md={6} key={index} className={item.field_type === 'date' ? 'margin-bottom-20' : ''}>
                                    <div className="form-group">
                                        <label>{item.field_name}</label>
                                        <div className="input-input">
                                            <React.Fragment>
                                                {(item.field_type === 'string') &&
                                                    <><input type="text" name={"txt_fieldValue_" + fieldId} value={this.state.vehicleInfoValue[fieldId] ? this.state.vehicleInfoValue[fieldId] : ''} onChange={(e) => this.onHandleVehicleInfoChange(e, item, 'string')} className={((!this.state.vehicleInfoValue[fieldId] || !this.state.vehicleInfoValue[fieldId].trim().length===0)&&this.state.initialValidation) ? 'input-error' : ''} /> 
                                                    </>
                                                }

                                                {(item.field_type === 'date') &&
                                                    <DatePicker
                                                        selected={this.state.vehicleInfoValue[fieldId] ? this.state.vehicleInfoValue[fieldId] : newDate}
                                                        onChange={dateVal => this.onHandleVehicleInfoChange(dateVal, item, 'date')}

                                                        placeholderText="Select a Date"
                                                        className={this.state.infoFormErrors[fieldId] ? this.state.infoFormErrors[fieldId] : ""}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        fixedHeight
                                                        autoComplete="off"
                                                        dateFormat={'dd/MM/yyyy'}
                                                    />
                                                }

                                            </React.Fragment>

                                        </div>
                                    </div>
                                </Col>)
                        })}
                    </Row>
                    <Row>
                        <Col md={6} >
                            <div className="custom-checkbox">
                                <input name={"chk_is_approved"} type="checkbox" id={"chk_is_approved"} checked={this.state.vehicleInfoValue.is_approved} onChange={(e) => this.onHandleIsApprovedChange(e)} /> <label className="checkbox" htmlFor={"chk_is_approved"}></label>
                                <label className="labeltext" htmlFor="chk_is_approved">{LBL_APPROVED}</label>
                            </div>
                        </Col>
                    </Row>
                </ModalWindow>
                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {MSG_DELETE_VECHICLE_DETAILS}
                </ModalWindow>

            </div></>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        fieldDetailsList: state.vehicleInfoData.fieldDetailsList,
        vehicleInfoList: state.vehicleInfoData.vehicleInfoList,
        vehicleInfoStatus: state.vehicleInfoData.vehicleInfoStatus,
        vehicleInfoActivity: state.vehicleInfoData.vehicleInfoActivity,
        fieldDetailsSavedList: state.vehicleInfoData.fieldDetailsSavedList,
        vehicleInfoRetrieve: state.vehicleInfoData.vehicleInfoRetrieve,
        dynFieldsAllItems: state.dynamicFields.dynFieldAllItems,
        dynFieldsStatus: state.dynamicFields.status,
        dynFieldsActivity: state.dynamicFields.activity,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        listFieldDetails: listFieldDetails,
        saveFieldDetails: saveFieldDetails,
        saveVehicleInfo: saveVehicleInfo,
        listVehicleInfo: listVehicleInfo,
        deleteVehicleInfo: deleteVehicleInfo,
        updateVehicleInfo: updateVehicleInfo,
        getVehicleInfo: getVehicleInfo,
        clearAction: clearAction,
        dynamicFieldsListAction: dynamicFieldsListAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateVehicleInfo);
